import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'ckeditor5/ckeditor5.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from '@emotion/react';
import { createTokens } from '@legion-ui/core';
import { frontConfig } from './config/front-config';
import 'react-quill/dist/quill.snow.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

const config = frontConfig();

const tokensBigBox = createTokens({
  apiUrl: config.themeUrl!,
  apiHeaders: { Accept: 'application/vnd.github.v3.raw' },
  tokensName: 'pijarTokens',
}); ///

const themeBigBox = {
  name: 'Pijar',
  tokens: tokensBigBox,
};

root.render(
  <React.StrictMode>
    <ThemeProvider theme={themeBigBox}>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
